import React from "react";

export function Machine({ size, opacity }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "17px"}
      height={(size * 18.889) / 17 || "18.889px"}
      viewBox="0,0,17,18.889"
      opacity={opacity || 1}
    >
      <path d="M.944.944v17h15.112v-17H.944M0 0h17v18.889H0Z" />
      <path d="M8.5 7.555a3.778 3.778 0 1 0 3.778 3.778A3.782 3.782 0 0 0 8.5 7.555m0-.944a4.722 4.722 0 1 1-4.722 4.722A4.722 4.722 0 0 1 8.5 6.611ZM16.552 4.597H.447v-.944h16.105Z" />
      <path d="M2 1.888h1v1H2z" className="a" />
      <path d="M1.889 1.889h.944v.944h-.944Z" />
      <path d="M14 1.888h1v1h-1z" className="a" />
      <path d="M14.167 1.889h.944v.944h-.944Z" />
      <path d="M12 1.888h1v1h-1z" className="a" />
      <path d="M12.278 1.889h.944v.944h-.944Z" />
      <path d="M10 1.888h1v1h-1z" className="a" />
      <path d="M10.389 1.889h.944v.944h-.944Z" />
    </svg>
  );
}

export function Hand({ size, opacity }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "24.078px"}
      height={(size * 16.195) / 24.078 || "16.195px"}
      viewBox="0,0,24.078,16.195"
      opacity={opacity || 1}
    >
      <path d="M20.567 16.195H3.505a.361.361 0 0 1-.351-.278L.005 2.66a.361.361 0 0 1 .7-.167l3.083 12.979h16.487l3.083-12.979a.361.361 0 0 1 .7.167l-3.149 13.257a.361.361 0 0 1-.342.278Z" />
      <path d="M16.526 6.034a.361.361 0 0 1 0-.722 2.934 2.934 0 0 0 1.964-.768 3.753 3.753 0 0 1 4.912 0 .361.361 0 0 1-.435.577 3.039 3.039 0 0 0-4.043 0 3.656 3.656 0 0 1-2.389.913ZM7.607 6.037a3.653 3.653 0 0 1-2.454-.915 3.035 3.035 0 0 0-4.032-.008l-.225-.283-.216-.289a3.751 3.751 0 0 1 4.907 0 2.931 2.931 0 0 0 2.019.77 3.259 3.259 0 0 0 .548-.043 2.377 2.377 0 0 0 .61-.183.362.362 0 0 1 .3.658 3.084 3.084 0 0 1-.79.237 3.97 3.97 0 0 1-.667.056ZM9.579 12.398a1.128 1.128 0 0 1-1-.607 1.069 1.069 0 0 1-.064-.837l1.931-5.719a.361.361 0 0 1 .684.231l-1.931 5.719a.353.353 0 0 0 .022.276.4.4 0 0 0 .228.194.377.377 0 0 0 .483-.222l1.422-4.211a.361.361 0 1 1 .684.231l-1.422 4.211a1.091 1.091 0 0 1-1.037.734Z" />
      <path d="M10.727 13.598a1.049 1.049 0 0 1-.336-.055 1.146 1.146 0 0 1-.675-1.47l1.638-4.852a.361.361 0 0 1 .684.231L10.4 12.304a.392.392 0 1 0 .733.247l1.638-4.852a.361.361 0 0 1 .684.231l-1.638 4.852a1.174 1.174 0 0 1-1.09.816Z" />
      <path d="M12.507 13.116a1.158 1.158 0 0 1-.371-.061 1.086 1.086 0 0 1-.713-1.357l1.349-4a.361.361 0 0 1 .685.231l-1.35 4a.364.364 0 0 0 .259.441.412.412 0 0 0 .3-.011.311.311 0 0 0 .171-.183l1.419-4.2a.361.361 0 0 1 .684.231l-1.418 4.2a1.026 1.026 0 0 1-.559.61 1.115 1.115 0 0 1-.456.099Z" />
      <path d="M14.384 12.41a1.342 1.342 0 0 1-.428-.072 1.013 1.013 0 0 1-.76-1.217l1.062-3.146a.361.361 0 0 1 .684.231l-1.062 3.146c-.021.061.083.226.306.3a.543.543 0 0 0 .328.015.15.15 0 0 0 .1-.069l1.116-3.306a9.279 9.279 0 0 0 .355-1.37 10.566 10.566 0 0 0 .024-2.427l-.033-.54a3.98 3.98 0 0 1 .2-1.479l.479-1.442a.361.361 0 1 1 .685.228l-.479 1.442a3.266 3.266 0 0 0-.167 1.212l.033.533a11.09 11.09 0 0 1-.034 2.6 10.027 10.027 0 0 1-.382 1.477l-1.116 3.306a.848.848 0 0 1-.564.527 1.158 1.158 0 0 1-.347.051ZM8.9 7.858a1.231 1.231 0 0 1-.578-.147 1.155 1.155 0 0 1-.389-1.515c.008-.013 1.1-1.585 1.4-1.984a9.6 9.6 0 0 1 2.044-1.928 3.343 3.343 0 0 0 1.2-1.643l.136-.4a.361.361 0 0 1 .683.234l-.135.393a4.059 4.059 0 0 1-1.452 1.994 9.03 9.03 0 0 0-1.9 1.78c-.3.395-1.371 1.949-1.371 1.95a.457.457 0 0 0 .148.492.4.4 0 0 0 .514-.091l1.295-1.852a.361.361 0 0 1 .592.414L9.801 7.393a1.067 1.067 0 0 1-.901.465Z" />
    </svg>
  );
}

export function Dry({ size, opacity }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "18px"}
      height={size || "18px"}
      viewBox="0,0,18,18"
      opacity={opacity || 1}
    >
      <g
        fill="none"
        stroke="#000000"
        strokeMiterlimit="10"
        transform="translate(.5 .5)"
      >
        <path d="M0 7.84c2.124 0 2.124 1.318 4.25 1.318S6.374 7.84 8.5 7.84s2.124 1.318 4.25 1.318S14.874 7.84 17 7.84" />
        <circle cx="8.5" cy="8.5" r="8.5" />
      </g>
    </svg>
  );
}

export function Glass({ size, opacity, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "16.354"}
      height={(size * 15.354) / 16.354 || "15.354"}
      viewBox="0,0,16.354,15.354"
      opacity={opacity || "1"}
    >
      <g fill="none" stroke={color || "#fff"}>
        <circle cx="7" cy="7" r="7" stroke="none" />
        <circle cx="7" cy="7" r="6.5" />
      </g>
      <path fill="none" stroke={color || "#fff"} d="m12 11 4 4" />
      <path fill="none" stroke={color || "#fff"} d="M4 7h6" />
      <path fill="none" stroke={color || "#fff"} d="M7 4v6" />
    </svg>
  );
}

export function Stock({ data }) {
  if (data === "無") {
    return (
      <b className="stock" style={{ backgroundColor: "#898989" }}>
        無
      </b>
    );
  }
  if (data === "注") {
    return (
      <b className="stock" style={{ backgroundColor: "#000000" }}>
        注
      </b>
    );
  }
}

export function Label({ data }) {
  if (data === "OLD") {
    return (
      <b className="labelnew" style={{ backgroundColor: "#898989" }}>
        OLD
      </b>
    );
  }
  if (data === "NEW") {
    return (
      <b className="labelnew" style={{ backgroundColor: "#000000" }}>
        NEW
      </b>
    );
  }
}

export function Picks({ data }) {
  if (data === "NOT") {
    return (
      <b className="labelnew" style={{ backgroundColor: "#898989" }}>
        NOT
      </b>
    );
  }
  if (data === "TOP") {
    return (
      <div className="picks" style={{ display: "inline-block"}}>
        <img 
          src="/material/images/badge/bestseller.png" 
          alt="Best Seller" 
          style={{ height: "auto"}}
        />
      </div>
    );
  }
}

export function Circle({ size, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "15px"}
      height={size || "15px"}
      viewBox="0,0,15,15"
    >
      <g fill="none" stroke={color || "#000000"} stroke-width="3">
        <circle cx="7.5" cy="7.5" r="7.5" stroke="none" />
        <circle cx="7.5" cy="7.5" r="6" />
      </g>
    </svg>
  );
}
export function Cross({ size, color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || "13.401px"}
      height={size || "13.401px"}
      viewBox="0,0,13.401,13.401"
    >
      <g fill="none" stroke={color || "#000000"} stroke-width="3">
        <path d="M1.061 1.061 12.34 12.34" />
        <path d="M12.34 1.061 1.061 12.34" />
      </g>
    </svg>
  );
}
